import {pick} from 'lodash';
import {getFeatureForExternal} from '../../features';
import {FeatureCardProps} from './FeatureCard';

export const featureList: FeatureCardProps[] = getFeatureForExternal().map((f) => ({
  ...pick(f, ['title', 'description', 'IconComponent', 'status']),
}));
//  [
//   {
//     title: 'Bulk Title & Tag Management',
//     description:
//       'Effortlessly manage and optimize your product titles and tags in bulk, saving time and improving your SEO.',
//     IconComponent: BulkEditIcon,
//     status: FeatureStatus.CURRENT,
//   },
//   {
//     title: 'Create digital listing',
//     description: 'Quick and easy to create digital listing with PDF generation if your files are hosted elsewhere',
//     IconComponent: AttachFile,
//     status: FeatureStatus.CURRENT,
//   },
//   {
//     title: 'Order Alerts',
//     description: 'Receive instant notifications for new orders, ensuring you never miss a sale.',
//     IconComponent: NotificationsActiveIcon,
//     status: FeatureStatus.UPCOMING,
//   },
//   {
//     title: 'Delivery Note Printing',
//     description: 'Quickly print delivery notes for faster order processing and shipping.',
//     IconComponent: LocalPrintshopIcon,
//     status: FeatureStatus.UPCOMING,
//   },
//   {
//     title: 'Bulk Item Upload',
//     description: 'Upload multiple items at once with customizable templates, streamlining your listing process.',
//     IconComponent: CloudUploadIcon,
//     status: FeatureStatus.UPCOMING,
//   },
//   {
//     title: 'Analytics Dashboard',
//     description: "Gain insights into your shop's performance with detailed analytics and reports.",
//     IconComponent: BarChartIcon,
//     status: FeatureStatus.UPCOMING,
//   },
//   {
//     title: 'SEO Optimization Tools',
//     description: 'Powerful tools to help you optimize your listings for Etsy search, increasing visibility and sales.',
//     IconComponent: SearchIcon,
//     status: FeatureStatus.UPCOMING,
//   },
// ];
